import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { IWorkShiftTimeSlot } from "../../models/workShiftTimeSlot/workShiftTimeSlot";

interface IWorkTimeDetails {
    current: IWorkShiftTimeSlot;
}

const StackItem = (props) => {
    return <Typography {...props} />;
};

export const WorkTimeDetails = ({ current }: IWorkTimeDetails) => {
    if (!current?.costCenterName) return null;

    const { costCenterName } = current;

    return (
        <Stack alignItems="center" mt={2}>
            <StackItem variant="h3" color="white.main">
                {costCenterName}
            </StackItem>
        </Stack>
    );
};
